<template lang="pug">
  .full-width
    v-overlay(
      v-if="isLoading",
      :value="isLoading"
    )
      v-progress-circular(:value="20" indeterminate)
    v-row(no-gutter)
      v-col(
        v-for="stat in stats",
        cols="12",
        sm="4",
        :key="stat.shop",
      )
        StatBox(
          :stats="stat",
          :labels="dateIndex",
        )
</template>

<script>
import { mapGetters } from 'vuex';
import { and, curryN, equals, find, prop, propOr, sortBy } from 'ramda';
import { progressWrapper } from '@/config/mixins.js';
import { buildDateRange, getEarlierDate } from '@/utils/time';

import StatBox from '@/components/elements/StatBox.vue';
const findShopData = curryN(
  3,
  (shop_id, date_index, { shop_id: data_shop_id, formattedDate }) =>
    and(equals(data_shop_id, shop_id), equals(formattedDate, date_index)),
);

export default {
  components: {
    StatBox,
  },

  mixins: [progressWrapper],

  data: () => ({
    stats: [],
    dateIndex: [],
  }),

  computed: {
    ...mapGetters({
      shops: 'shop/items',
    }),
  },

  created() {
    this.wrapProgress(() =>
      Promise.all([
        this.$store.dispatch('shop/fetch', { hardFetch: true }),
        this.$store.dispatch('statistic/media'),
        this.$store.dispatch('statistic/customer'),
      ]).then(this.buildCharts),
    );
  },

  methods: {
    buildCharts([, mediaData, customerData]) {
      const startDate = getEarlierDate(mediaData[0].date, customerData[0].date);
      this.dateIndex = buildDateRange(startDate);

      const list = [
        {
          name: 'Total',
          analysis: [],
          customer: [],
        },
      ];
      const shops = sortBy(prop('createdAt'), this.shops);
      shops.forEach(shop => {
        const chart = {
          name: shop.name,
          analysis: [],
          customer: [],
        };
        this.dateIndex.forEach((index, key) => {
          const analysisCount = propOr(
            0,
            'count',
            find(findShopData(shop.id, index), mediaData),
          );
          const customerCount = propOr(
            0,
            'count',
            find(findShopData(shop.id, index), customerData),
          );
          chart.analysis.push(analysisCount);
          chart.customer.push(customerCount);

          // compute total
          list[0].analysis[key] = list[0].analysis[key]
            ? list[0].analysis[key] + analysisCount
            : analysisCount;
          list[0].customer[key] = list[0].customer[key]
            ? list[0].customer[key] + customerCount
            : customerCount;
        });

        list.push(chart);
      });

      this.stats = list;
    },
  },
};
</script>
